import React, { FC } from 'react';
import { Flex, Text, Box } from '@rebass/emotion';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps } from 'react-router-dom';
import messages from './Footer.messages';
import InjectIntl from '../InjectIntl/InjectIntl';
import styles, { ManageCookie } from './Footer.styles';
import { APP_LANGUAGES_LABELS } from '../../../config/common.config';
import canUseDOM from '../../helpers/canUseDOM';

const isCookieConsentEnabled = (): boolean => {
  try {
    return canUseDOM() && window.CookieConsent.isRequired();
  } catch (e) {
    return false;
  }
};

const Footer: FC<RouteComponentProps<{ language: string }>> = (props) => (
  <InjectIntl>
    {({ locale }) => {
      /* TODO: Fetch these links dynamically from Typo3 or whatever content
          management system holds these in the future.
      */
      const LINKS = {
        legal: `https://www.native-instruments.com/${locale}/company/legal-information/`,
        privacy: `https://www.native-instruments.com/${locale}/company/legal-information/privacy-policy/`,
        contact: `https://www.native-instruments.com/${locale}/company/contact-ni/`,
        faq: `https://www.native-instruments.com/${locale}/shop-information/`,
      };

      /* FIXME: <Link> component doesn't work correctly at the moment!
         This is a workaround to change the language using a full page refresh.
      */
      const changeLanguage = (newLanguage = 'en'): void => {
        const { pathname } = props.location;
        const { language } = props.match.params;
        props.history.push(pathname.replace(language, newLanguage));
        window.location.reload();
      };

      return (
        <footer>
          <Box css={styles.wrapper}>
            <Flex flexWrap="wrap" css={styles.menuLink}>
              <Text
                width={[1, 1, 1 / 3]}
                pb={[2, 2, 0]}
                textAlign={['center', 'center', 'left']}
              >
                &copy;
                {new Date().getFullYear()} Native Instruments GmbH
              </Text>

              <Flex
                justifyContent="center"
                flexWrap="wrap"
                pb={[2, 2, 0]}
                px={2}
                width={[1, 1, 1 / 3]}
                css={styles.menuLink}
              >
                <a css={styles.linkClass} href={LINKS.legal}>
                  <FormattedMessage {...messages.legal} />
                </a>
                <a css={styles.linkClass} href={LINKS.privacy}>
                  <FormattedMessage {...messages.privacy} />
                </a>
                <a css={styles.linkClass} href={LINKS.contact}>
                  <FormattedMessage {...messages.contact} />
                </a>
                <a css={styles.linkClass} href={LINKS.faq}>
                  <FormattedMessage {...messages.faq} />
                </a>

                {isCookieConsentEnabled() && (
                  <ManageCookie onClick={window.CookieConsent.toggle}>
                    <FormattedMessage {...messages.manageCookie} />
                  </ManageCookie>
                )}
              </Flex>

              <Flex
                justifyContent={['center', 'center', 'flex-end']}
                css={styles.menuLink}
                width={[1, 1, 1 / 3]}
              >
                {Object.keys(APP_LANGUAGES_LABELS).map((key) => {
                  return (
                    <Text
                      key={key}
                      css={styles.linkClass}
                      onClick={() => changeLanguage(key)}
                    >
                      {APP_LANGUAGES_LABELS[key]}
                    </Text>
                  );
                })}
              </Flex>
            </Flex>
          </Box>
        </footer>
      );
    }}
  </InjectIntl>
);

export default Footer;
